<template>

    <div   ref="chatContatiner" style="height: 100%; 
    overflow-y: auto;   "  @scroll="showScorll"   :class="{'chatContatiner':arrayList && arrayList.length > 0}" id="listContainer">

        <template v-if="arrayList && arrayList.length > 0">
            <div v-for="item, index in arrayList" :id="'QICON' + index" style="margin-bottom: 20px;" v-bind:key="index">

                <template v-if="item.msgType == 0">
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="QICON">
                            <template v-if="item.load == true">
                                <div class="QICONIcon" style="text-align: center;">
                                    <SyncOutlined style="font-size: 16px;color: white;" spin></SyncOutlined>
                                </div>



                            </template>
                            <template v-else>
                                <img src="../../../assets/ailogo.png" style="width: 100%;position: relative;" />
                            </template>
                        </div>
                        <!-- <div style="align-content: center;font-size: 16px;font-weight: bolder;    margin-left: 5px;">
                            Qiuu~
                        </div> -->
                    </div>
                    <div style="font-size: 16px;" v-if="!item.load == true">
                        <div v-if="articleType == '网络搜索' && item.msgType == 0 && getArrayType(item.data)"
                            style="text-align: justify;">
                            <div class="chat-bubble chat-bubble-left ai-chat">
                                <div v-for="(itemItem, index) in item.data" v-bind:key="index" style="margin-bottom: 20px;">
                                <div>
                                    <a :href="itemItem.link" target="_blank">
                                        <span style="font-weight: bolder;">{{ index + 1 }}、{{ itemItem.title }}</span>
                                    </a>
                                </div>
                                <div>
                                    {{ itemItem.content }}...
                                </div>

                            </div>
                            </div>
                          

                        </div>
                  
                        <div v-else style="font-size: 16px;width: 100%;">
                                <div  class="chat-bubble chat-bubble-left ai-chat" >
                                
                                    <div  class="html"  v-html="md.render(item.data) "></div>
                                </div>


                            </div>


                    </div>
                </template>
                <template v-if="item.msgType == 1">

                    <div style="    text-align: right;
    display: flex;
    width: 100%;
    justify-content: flex-end;

">
                   
                          
                            <div style="font-size: 16px;width: 100%;">
                                <div  class="chat-bubble chat-bubble-right" >
                                   <span style="white-space: pre-line">{{item.data }}</span>
                                </div>


                            </div>
                        
                    </div>

                </template>


            </div>
        </template>
    </div>

</template>
<script setup>

import { nextTick, onMounted, reactive, ref, watch, defineProps, defineEmits } from 'vue'
import { SyncOutlined } from "@ant-design/icons-vue"
import { toChatPage } from '../../knowledgeComponent/qiuuindex';
import {articleRecordPage} from '../qiuuindex'
import MarkdownIt from 'markdown-it'

import store from '@/store';
const showProp = defineProps(['postParams',  'sendText', 'active', 'conversationId', 'articleAppId', 'articleType','articleId'])
const showEmit = defineEmits(['toChangeSelectTrue', 'toChangeSendText', 'toChangeSendTextTrue', 'toReloadSession', "toShow"])
const total=ref(0)
const md = new MarkdownIt({ html: true})
const pageStlye = ref()


const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
const avatarSrc = ref(store.getters.avatar)
const pagination = reactive({
    current: 1,
    size: 10,
    total: 0,
    pages: 0,

})
const chatContatiner=ref(null)
const handelWheel=(e)=>{
    
    console.log('wheel',e)
    if( event.deltaY < 0 && chatContatiner.value.scrollTop === 0&&  reloaddataFlag.value==false){
            if (pageScrollButtom.value==true&&pagination.pages > pagination.current) {
                reloaddataFlag.value=true
            pagination.current = pagination.current + 1
            const previousScrollHeight = chatContatiner.value.scrollHeight;
reloaddata(true, false) 

     
   
  
}
else{
   pageScrollButtom.value=true
}
    }


}
const reloaddataFlag=ref(false)
const previousScrollHeight=ref(0)
const showScorll = (e) => {

    let scrollTop = e.target.scrollTop;
    // console.log(scrollTop,'scrollTop')
    //     console.log(pagination.pages, pagination.current, "showScorll", pagination.current + 1,pagination.current)
        // const currentScrollTop = event.target.scrollTop;

        if (chatContatiner.value.scrollTop ==0&&pageScrollButtom.value==true&&pagination.pages > pagination.current&&arrayList.value.length>0) {
  
            reloaddataFlag.value=true
            pagination.current = pagination.current + 1
            const previousScrollHeight = chatContatiner.value.scrollHeight;
        
reloaddata(true, false) 

   
   
  
}
else{
   pageScrollButtom.value=true
}

      



}
const getArrayType = (value) => {
    if (value && Array.isArray(value)) return true
    return false
}
const reloaddata = (val, scrollFlag,onmountedFlag) => {

    showEmit('toChangeSelectTrue', true)
    if (val == true) {
  
        
        articleRecordPage({
        articleId:showProp.articleId,
        clientId: store.getters.clientId,
        companyId: store.getters.company.companyId,
        current: pagination.current,
        size: 10
    })  .then((res) => {
            pagination.total = res.data.total
            pagination.pages = res.data.pages
            var result = res.data.records
   
           if(scrollFlag!=null){
            if(res.data.records.length>0) showEmit('toShow')
            var list =arrayList.value
            for (var i in result) {


                list.push({ id: result[i].id, table: false, load: false, data: result[i].message, msgType: result[i].msgType })
            }
            if(arrayList.value.length > 0){
                arrayList.value = [...new Set(list)]
            }
            arrayList.value = arrayList.value.length > 0 ? arrayList.value.sort((a, b) => a.id - b.id) : arrayList.value
            console.log(arrayList.value, "arrayList.value")

            showEmit('toChangeSendText')
            showEmit('toChangeSelectTrue', false)
            // if(reloaddataFlag.data==true)
            // nextTick(()=>{
            //     const currentScrollHeight = chatContatiner.value.scrollHeight;
            //     chatContatiner.value.scrollTop = currentScrollHeight - previousScrollHeight.value;
            //     reloaddataFlag.value=false
            // })
            if (scrollFlag != false)
                nextTick(()=>{
         
                    scrollButtom(false)
                })
           }

        })


    }
    else {
        var result
        var postData = showProp.postParams
        if (val == false) {
            result = {
                load: false,
                data: showProp.sendText.sendText,
                summary: null,
                type: postData,
                table: false,
                msgType: 1,
                id: arrayList.value.length > 0 ? arrayList.value[arrayList.value.length - 1].id + 1 : 1
            }
            postData = {

                articleId:showProp.articleId,
                clientId: store.getters.clientId,
                companyId: store.getters.company.companyId,

                "question": showProp.sendText.sendText,
                "type": 0,
            }
            arrayList.value.push(result)
            showEmit('toChangeSendText')
        }

        arrayList.value.push({ load: true, msgType: 0, id: arrayList.value[arrayList.value.length - 1].id + 1 })

        nextTick(() => {
            var element = document.getElementById('listContainer');
            console.log(element)
            if (element) {
                //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                element.scrollTop = element.scrollHeight;
            }

            showEmit('toChangeSendTextTrue', true)
            showEmit('toShow')
            pageStlye.value = { 'height':  '100%', 'overflow-y': 'auto', 'padding': '20px' }





            toChatPage(postData).then((res) => {
                setChat(res, postData);
                console.log('xixitoChatPage')


            }).catch((error) => {

                console.log(error, 'xixicatch')
            })
        })
    }
    const setChat = (res, postData) => {
        console.log(res.data, "xixi1")
        var flag = false
        res = { data: res.data }
        var result = {
            load: false,
            data: [],
            summary: null,
            type: postData,
            table: false,
            msgType: 0,
            id: arrayList.value[arrayList.value.length - 1].id + 1
        }

     
        if (res == null||!res.data)
            result.data = "网络异常，请重新提问"
        else 
            
            result.data = res.data.msg[1].message
        flag=true

        // if (res.content && res.content[0] && res.content[0].projects) {
        //     result.data = res.content[0].projects
        //     result.summary = toSummary(showProp.postParams.category_str, res.content[0].summary)

        // }
        // else {

        //     result.summary = res.summary.response.data.detail

        // }
        arrayList.value[arrayList.value.length - 1] = (result)
        console.log(arrayList.value, 'result')
        // if (showProp.active.active == 'newChat') {

        //     showEmit('toChangeSessionList', res)
        // }
        showEmit('toChangeSendTextTrue', false)
        showEmit('toChangeSelectTrue', false)
        pagination.total = arrayList.value.length

        nextTick(()=>{
            scrollButtom(flag)
            reloaddata(true,null)
        })
 



    }


    // getArticleAnalysis(showProp.postParams).then((res) => {

    //     console.log(res)
    //     var result = {
    //         load: false,
    //         data: [],
    //         summary: null,
    //         type: showProp.postParams,
    //     }
    //     if (res.content && res.content[0] && res.content[0].projects) {
    //         result.data = res.content[0].projects
    //         result.summary = toSummary(showProp.postParams.category_str, res.content[0].summary)

    //     }
    //     else {
    //         result.summary = res.summary.response.data.detail

    //     }
    //     arrayList.value[arrayList.value.length - 1] = result
    //     console.log(arrayList.value, ' arrayList.value')
    //     showEmit('toChangeSelectTrue', false)

    // })
}


const pageScrollButtom =ref(true)
const scrollButtom = (flag) => {
  






    if(pagination.current==1)  pageScrollButtom.value=false
    nextTick(() => {

        var element

if (flag == true ||flag==false) {
    if (arrayList.value.length > 2) {
        element = document.getElementById('QICON' + (arrayList.value.length - 1).toString());
        var pelement = document.getElementById('listContainer');
        console.log(element, 'QICON' + pelement.clientHeight, pelement.scrollTop, element.offsetTop - 100)
        pelement.scrollTop = element.offsetTop - 100
         }

}
else {
    element = document.getElementById('listContainer');
    // console.log(element, 'element.scrollHeight', element.scrollHeight)
    if (element) {
        //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
        element.scrollTop = element.scrollHeight;
    
    }
}
       


    })
}
const isArray = (val) => {
    return val instanceof Array
}







const arrayList = ref([

])
watch(() => showProp.postParams, (val) => {

    if (val != null) {
        reloaddata()
    }
})

watch(() => showProp.sendText, (val) => {
    console.log(val, 'showProp.sendText')
    if (val != null && val.send == true) {
        reloaddata(false)
    }
})

onMounted(() => {
    reloaddata(true,true,true)




})
</script>
<style lang="less" scoped>

.html{
    padding: 0px 5px;
    padding-left: 10px;
   
//    li::marker {
//   color: red;
//   font-size: 1.5em;
//   margin-left:10px;
  
  
// }
    p{
        margin-bottom: 0px;
        white-space: pre-line;
    }
    img{
        width: -webkit-fill-available;
    }
    
}
</style>
<style lang="less">

.markdown {
    td {
        padding-right: 20px;
    }
}

.chatTable {
    thead tr th:nth-of-type(1) {
        padding: 1px;
    }

}

ul {
    list-style-type: none;
}
</style>
<style scoped>
.chatContatiner{
    padding: 0px 20px;;
}
.chat-bubble{
  color: #333;
  border-radius: 5px;
  box-shadow: 3px 5px 15px rgba(0,0,0,.2);
  padding: 5px 10px;
  width: auto;
  max-width: 100%;
  text-align: left;
  display: inline-block !important;
  position: relative;
  word-break:break-all;
  background-color: #ffffff;
  transition: all .2s;
  cursor: pointer;
}
.chat-bubble:hover{
  transform: scale(1.03);
}
.chat-bubble-left{

}
.chat-bubble-left.ai-chat{
    border: 1px solid;
    border-image: linear-gradient(90deg, #725bdf 0%, #80a3d5 70%, #bdceea 100%) 1 1 1 1;

}


.chat-bubble-left::before{
  content: '';
  width: 10px;
  height: 10px;
  left: -10px;
  top: calc(50% - 5px);
  position: absolute;
  border-left: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
  border-right: 5px solid #7d93d7;
}
.chat-bubble-right{
    background-color: #e0dfff;
}
.chat-bubble-right:after{
  content: '';
  width: 10px;
  height: 10px;
  right: -10px;
  top: calc(50% - 5px);
  position: absolute;
  border-left: 5px solid #e0dfff;
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
  border-right: 5px solid transparent;
}

.chatContainer {
    padding: 10px;
}
.QICONIcon {
    display: flex;
    width: 100%;
    height: 100%;
    background: #725bdf;
    align-items: center;
    justify-content: center;
}

.QICON {
    margin-bottom: 10px;
    width: 30px;
    height: 30px;

    display: flex;
    justify-content: center;
    align-items: center;


}
</style>